import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SAF_BASIC_02_Schema } from './SAF_BASIC_02_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess, context } = options;

  const query = useQuery({
    queryKey: [
      'SafeWorkProcedure',
      'getSafBasic02R1',
      context?.search?.custCd || '',
      context?.search?.depCd || '',
      context?.search?.workStartDate || context?.search?.startDate || '',
      context?.search?.workEndDate || context?.search?.endDate || '',
      context?.search?.gubun || '',
      context?.search?.searchText || '',
    ],
    queryFn: () => {
      const params = mapParamsBySchema(
        SAF_BASIC_02_Schema.mapper.search1,
        context
      );
      return apiRequest(
        'post',
        Global.urls.SafeWorkProcedure.getSafBasic02R1,
        params
      );
    },
    enabled: false,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// 안전작업허가서 상세 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAF_BASIC_02_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafeWorkProcedure.getSafBasic02R2,
      params
    );
  }, successOptions);
};

// 안전작업허가서 반려이력 조회
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SAF_BASIC_02_Schema.mapper.search3,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SafeWorkProcedure.getSafBasic02R3,
      params
    );
  }, successOptions);
};

// 안전작업허가서 반려/승인 저장 (SaveSafBasic02U2)
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows, context = {}) => {
    const payload = mapRowsBySchema(
      rows,
      SAF_BASIC_02_Schema.mapper.save2,
      context
    );

    return apiRequest(
      'post1',
      Global.urls.SafeWorkProcedure.saveSafBasic02U2,
      payload
    );
  }, options);
};

// 안전작업허가서 삭제
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, SAF_BASIC_02_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.SafeWorkProcedure.deleteSafBasic02D1,
      payload
    );
  }, options);
};
